import React from 'react';
import { motion } from 'framer-motion';
import { CloudRain, Zap } from 'lucide-react';
export function TrianguloNoche() {
  const steps = [{
    step: 'Día 1',
    action: 'Descarga y haz tu Auditoría de Activos',
    result: 'Conoces exactamente con cuánto cuentas'
  }, {
    step: 'Día 7',
    action: 'Documentos en proceso + país elegido',
    result: 'Tienes un mapa claro y legal'
  }, {
    step: 'Día 30',
    action: 'Trámites iniciados desde EE.UU.',
    result: 'Tu capital empieza a abrir puertas'
  }, {
    step: 'Día 60',
    action: 'Preparación de salida estratégica',
    result: 'Sin bloqueos bancarios ni sorpresas'
  }, {
    step: 'Día 90',
    action: 'Residencia legal + ahorros trabajando',
    result: 'Libertad para caminar sin mirar atrás'
  }];
  return <section className="py-8 md:py-14 px-4 md:px-6 relative overflow-hidden" style={{
    backgroundColor: 'var(--bg-surface)'
  }} data-id="element-469">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-[var(--accent)] opacity-[0.04] blur-[120px] rounded-full pointer-events-none" data-id="element-470" />

      <div className="max-w-[720px] mx-auto relative z-10" data-id="element-471">
        <div className="text-center mb-6 md:mb-10" data-id="element-472">
          <p className="text-[var(--accent)] text-xs font-bold tracking-widest uppercase mb-2" data-id="element-473">
            El Mecanismo Único
          </p>
          <h2 className="text-xl md:text-3xl font-serif text-[var(--text-heading)] mb-2 md:mb-4" data-id="element-474">
            El Protocolo Plan B:{' '}
            <span className="text-[var(--text-muted)] italic" data-id="element-475">
              Auditoría de Salida + Relocalización Legal.
            </span>
          </h2>
          <p className="text-[var(--text-muted)] text-sm md:text-base max-w-lg mx-auto" data-id="element-476">
            No es migración de pobre. Es reubicación estratégica.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-3 md:gap-6 items-center mb-6 md:mb-10" data-id="element-477">
          <div className="bg-[var(--bg-elevated)] p-4 md:p-6 rounded-lg border border-[var(--border-subtle)] opacity-70" data-id="element-478">
            <div className="flex items-center gap-2 mb-2 text-[var(--text-muted)]" data-id="element-479">
              <Zap className="w-4 h-4" data-id="element-480" />
              <h3 className="font-bold uppercase tracking-wide text-xs" data-id="element-481">
                La Falsa Esperanza
              </h3>
            </div>
            <p className="text-xs md:text-sm leading-relaxed text-[var(--text-muted)]" data-id="element-482">
              Esperar una reforma migratoria que lleva 20 años prometiéndose y
              nunca llega.
            </p>
          </div>

          <div className="bg-[var(--bg-card)] p-4 md:p-6 rounded-lg border border-[var(--accent)]/25 shadow-sm relative overflow-hidden" data-id="element-483">
            <div className="absolute top-0 left-0 w-1 h-full bg-[var(--accent)]" data-id="element-484"></div>
            <div className="flex items-center gap-2 mb-2 text-[var(--accent)]" data-id="element-485">
              <CloudRain className="w-4 h-4" data-id="element-486" />
              <h3 className="font-bold uppercase tracking-wide text-xs" data-id="element-487">
                La Salida Estratégica
              </h3>
            </div>
            <p className="text-[var(--text-primary)] text-xs md:text-sm leading-relaxed font-medium" data-id="element-488">
              Usar tratados iberoamericanos y leyes de inversión para pasar de
              "indocumentado" a "residente legal" en 90 días.
            </p>
          </div>
        </div>

        {/* The mechanism */}
        <div className="bg-[var(--bg-card)] rounded-xl border border-[var(--accent)]/20 p-4 md:p-6 mb-5 md:mb-8" data-id="element-489">
          <h3 className="text-lg md:text-xl font-serif text-[var(--text-heading)] text-center mb-1" data-id="element-490">
            ⚡ El Plan de 90 Días
          </h3>
          <p className="text-center text-[var(--text-muted)] text-xs mb-4 italic" data-id="element-491">
            Diseñado para convertir tus dólares acumulados en tu boleto de oro.
          </p>
          <div className="space-y-2 md:space-y-3" data-id="element-492">
            {steps.map((s, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className="flex flex-col md:grid md:grid-cols-[auto_1fr_1fr] gap-1 md:gap-3 items-start text-xs md:text-sm border-b border-[var(--border-subtle)] pb-2 md:pb-3 last:border-0 last:pb-0" data-id="element-493">
                <span className="text-[var(--accent)] font-bold text-[10px] md:text-xs uppercase tracking-wide md:w-24" data-id="element-494">
                  {s.step}
                </span>
                <span className="text-[var(--text-muted)]" data-id="element-495">{s.action}</span>
                <span className="text-[var(--text-primary)] font-medium" data-id="element-496">
                  {s.result}
                </span>
              </motion.div>)}
          </div>
        </div>

        <div className="text-center space-y-2 md:space-y-3" data-id="element-497">
          <p className="text-base md:text-lg text-[var(--text-muted)] max-w-xl mx-auto" data-id="element-498">
            Tus ahorros son la llave hacia tu{' '}
            <span className="text-[var(--accent)] font-bold" data-id="element-499">
              libertad legal
            </span>
            .
          </p>
          <p className="text-[var(--text-primary)] italic font-serif text-lg md:text-xl" data-id="element-500">
            "Así es como recuperas el control de tu vida."
          </p>
        </div>
      </div>
    </section>;
}